import appSagas from 'redux/app/sagas';
import { sagas as authSagas } from 'features/authentication';
import uiSagas from 'redux/ui/sagas';
import userSagas from 'redux/user/sagas';
import casesSagas from 'redux/cases/sagas';
import assetsSagas from 'redux/assets/sagas';
import serviceProvidersSagas from 'redux/serviceProviders/sagas';
import serviceRequestsSagas from 'redux/serviceRequests/sagas';

export default function* rootSaga() {
  yield [
    ...appSagas,
    ...authSagas,
    ...uiSagas,
    ...userSagas,
    ...casesSagas,
    ...assetsSagas,
    ...serviceProvidersSagas,
    ...serviceRequestsSagas,
  ];
}



// WEBPACK FOOTER //
// ./setup/sagas.js